import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS } from './constants'

export const DONATION_GRID_STEP_NAME = 'donation-grid'

export const makeDonationGridStep = (): FlowStep => {
  return {
    name: DONATION_GRID_STEP_NAME,
    title: '',
    enabled: true,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: 'flow-two-column',
  }
}
